// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1a1jK","header":"ReportDetails_header__1IZBI","title":"ReportDetails_title__1bU5U","left":"ReportDetails_left__2GAhj"};